import { JssState } from "./types"

const state = (): JssState => ({
  statusCode: '',
  context: null,
  route: null,
  isExperienceEditor: false
})

export default state
